import React from 'react';
import { Box } from '@wds/box';
import { Button } from '@wds/button';

import PropTypes from 'prop-types';
import STRINGS from '../../../constants';
import CardTemplate from '../../../../sma.common/components/react/components/CardTemplate';
import EligibilityContent from '../../components/EligibilityContent';

const tabStrings = STRINGS.accountSettingsPage.userEligibilityTab;

const EligibilityTab = (props) => {
	const { settings, siteInfo, userDetails, handleEditEligibility } = props;

	return (
		<>
			{
				settings?.roles
				&& settings.roles.includes('applicant')
				&& siteInfo?.eligibilityEnabled
				&& (
					<CardTemplate
						cardTitle={tabStrings.title}
						id='eligibility'
					>
						{userDetails.eligibility.can_edit === true && (
							<Box>
								<Button
									id='sma-edit-eligibility'
									onClick={() => handleEditEligibility()}
								>
									{
										userDetails.eligibility.in_progess
											? tabStrings.completeEligibilityProfileBtn
											: tabStrings.fillOutEligibilityBtn
									}
								</Button>
							</Box>
						)}
						<Box id='sma-eligibility-data' display='flex' mt={2}>
							<EligibilityContent eligibility={userDetails.eligibility} />
						</Box>
					</CardTemplate>
				)
			}
		</>
	);
};

EligibilityTab.propTypes = {
	settings: PropTypes.object.isRequired,
	siteInfo: PropTypes.object.isRequired,
	userDetails: PropTypes.object.isRequired,
	handleEditEligibility: PropTypes.func.isRequired,
};

export default EligibilityTab;
